import cn from 'classnames';

import type { Vertical } from 'shared/search/common/config';

import styles from './HeroBanner.module.css';

interface HeroBannerProps {
    vertical: Vertical;
    children?: React.ReactNode;
}

export const HeroBanner = ({ vertical, children }: HeroBannerProps) => {
    return (
        <div
            className={cn(styles['hero-banner'], {
                [styles[`hero-banner--${vertical}`]]: vertical,
            })}>
            <div className={styles['hero-banner__content-wrapper']}>{children}</div>
        </div>
    );
};
